module.exports = __webpack_public_path__ + "img/share-variant-outline.af2eb22c.svg";